import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen pt-32 pb-20 flex items-center justify-center" data-testid="error-boundary-fallback">
          <div className="text-center px-6">
            <h1 className="text-3xl font-bold text-white mb-3">Something went wrong</h1>
            <p className="text-gray-400 mb-6">An unexpected error occurred while loading this page.</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => window.location.reload()}
                className="px-5 py-2.5 rounded-full bg-[#00E676] text-black font-bold hover:bg-[#00C853] transition-colors"
                data-testid="error-reload-btn"
              >
                Reload page
              </button>
              <a href="/" className="px-5 py-2.5 rounded-full border border-white/20 text-white font-bold hover:border-[#00E676] hover:text-[#00E676] transition-colors">
                Go home
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
